import Index from './views/Index'

export default [{
  path: '/partner/:code/reports',
  name: 'partner.reports',
  component: Index
}]
